/* eslint-disable no-empty-pattern */
/* eslint-disable no-shadow */
import IRetailer from '@/models/retailer/interfaces/retailer.d';
import SearchQuery from '@/models/SearchQuery';
import IRetailerVehicleAvailability from '@/models/test-drive/interfaces/retailer-vehicle-availability.d';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import { retailerService } from '@/services/RetailerService';
import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import IRootState from '../states/interfaces/index.d';
import IRetailerState from '../states/interfaces/retailer-state.d';
import RetailerState from '../states/retailer-state';
import { addRetailerKeys, removeRetailerKeys } from '../utils/retailer';

export const state: IRetailerState = new RetailerState();

export const getters: GetterTree<IRetailerState, IRootState> = {
  retailers: (state): IRetailer[] => state.retailersWithAvailability,
  selectedRetailer: (state): IRetailerVehicleAvailability | null => state.selectedRetailer,
  selectedRetailerId: (state): number => (state.selectedRetailer ? state.selectedRetailer.retailerId : 0)
};

export const mutations: MutationTree<IRetailerState> = {
  setRetailersWithAvailability: (state: IRetailerState, retailers: IRetailerVehicleAvailability[]) => {
    state.retailersWithAvailability = retailers;
  },
  setSelectedRetailer: (state: IRetailerState, retailer: IRetailerVehicleAvailability) => {
    state.selectedRetailer = retailer;
  }
};

export const actions: ActionTree<IRetailerState, IRootState> = {
  async submitSelectedRetailerId({ commit, dispatch, state }, id: number) {
    const retailer = state.retailersWithAvailability.find(({ retailerId }) => retailerId === id);

    if (retailer && retailer.retailerId > 0) {
      commit('setSelectedRetailer', retailer);
      addRetailerKeys(retailer, dispatch);
    } else {
      removeRetailerKeys(dispatch);
    }
  },
  async submitRetrieveRetailers({
    commit, dispatch, rootState, rootGetters
  }, retailerLimit: number) {
    const { vehicleType } = rootState.initialSettingsModule.initialSettings;
    const vehicle: IVehicle | null = rootGetters['vehicleModule/currentVehicle'];
    const searchQuery: SearchQuery = rootGetters['searchQueryModule/searchQuery'];

    if (!vehicle
      || rootState.addressModule.address.latitude === 0
      || rootState.addressModule.address.longitude === 0) {
      dispatch('submitResetSelection');
      return;
    }

    const result = await retailerService.getAvailability(
      vehicleType,
      vehicle.manufacturerId,
      vehicle.rangeId,
      vehicle.modelId,
      searchQuery.bodystyles ? searchQuery.bodystyles[0] : null,
      searchQuery.fuelTypes ? searchQuery.fuelTypes[0] : null,
      rootState.addressModule.address.latitude,
      rootState.addressModule.address.longitude,
      retailerLimit
    );

    if (result && result.length > 0) {
      commit('setRetailersWithAvailability', result);
    } else {
      console.warn(
        'No Retailers Found',
        vehicle.manufacturerId,
        rootState.addressModule.address.latitude,
        rootState.addressModule.address.longitude
      );
      
      commit('setRetailersWithAvailability', []);
      dispatch('submitResetSelection');
    }
  },
  submitResetSelection({ commit, dispatch }) {
    removeRetailerKeys(dispatch);
    commit('setRetailersWithAvailability', []);
    commit('setSelectedRetailer', null);
    dispatch('testDriveAvailabilityModule/submitResetSelection', null, { root: true });
  }
};

export const retailerModule: Module<IRetailerState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
